// extracted by mini-css-extract-plugin
export default {"BodyContainer":"_BodyContainer--SvbRJ","TerminateIcon":"_TerminateIcon--HOOGS","SharedTemplateIcon":"_SharedTemplateIcon--t7Vkn","Heading":"_Heading--tZuLz"};